export enum FirebaseServiceError {
  FirestoreDocumentGetError = 'firebase-service/firestore-document-get-error',
  FirestoreDocumentSetError = 'firebase-service/firestore-document-set-error',
  FirestoreDocumentUpdateError = 'firebase-service/firestore-document-update-error',
  FirestoreDocumentDeleteError = 'firebase-service/firestore-document-delete-error',
  AccountDeleteError = 'firebase-service/account-delete-error',
}
